// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#expiredTab {
  height: 100%;
}
#expiredTab .p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close,
#expiredTab .p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close,
#expiredTab .p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close,
#expiredTab .p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close {
  position: absolute;
  right: 4px;
  top: 4px;
  color: #828282;
}
#expiredTab .p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close .pi,
#expiredTab .p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close .pi,
#expiredTab .p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close .pi,
#expiredTab .p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close .pi {
  font-weight: bold;
}
#expiredTab .body {
  height: 85%;
}
#expiredTab .layout-topbar-logo {
  align-items: center;
}
#expiredTab p {
  margin-left: 20px;
  margin-top: 20px;
}
#expiredTab .font-size-header {
  display: flex;
  align-items: baseline;
  font-size: 1rem;
  color: #1d2125;
  font-weight: normal;
}
#expiredTab .font-size-header button {
  font-size: 10px;
  width: 2rem;
  margin-top: 4px;
}
#expiredTab .font-size-header button ::ng-deep .pi-chevron-right {
  font-size: 10px;
  line-height: 9px;
}
#expiredTab .cursor {
  cursor: pointer;
}
#expiredTab .bdp-map-wrapper {
  position: relative;
}
#expiredTab .bdp-map-wrapper #bdpDraggableWrapper {
  overflow: hidden;
}
#expiredTab .bdp-map-wrapper #tntDetailedMap {
  height: 500px;
}
#expiredTab .bdp-map-wrapper .ng-resizable-handle.ng-resizable-s {
  height: 15px;
}
#expiredTab .bdp-map-wrapper .ng-resizable-handle.ng-resizable-s::after {
  /* width: 46px; */
  /* height: 0px; */
  content: "";
  /* margin-left: auto; */
  /* margin-right: 10px; */
  /* display: block; */
  /* margin-top: 3px; */
  /* border-bottom: 7px solid #d3d3d4; */
  float: right;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 30px solid transparent;
  border-right: 12px solid #c9c9d0;
  cursor: n-resize;
}
#expiredTab .bdp-map-wrapper .bdp-switch-wrapper {
  position: absolute;
  bottom: 24px;
  left: 25px;
  background: #fff;
  padding: 4px 5px 2px 5px;
  border-radius: 5px;
}
#expiredTab .bdp-map-wrapper .bdp-switch-wrapper > span {
  float: right;
  margin-left: 15px;
}
#expiredTab ::ng-deep button.p-button {
  background-color: var(--bdpButtonSecondary);
  color: var(--bdpFontPrimary);
  border: 1px solid #d7d8d9;
}
#expiredTab ::ng-deep button.p-button.bdp-export-button {
  width: 36px;
  height: 36px;
  margin-left: 1rem;
}
#expiredTab ::ng-deep .p-inputswitch {
  height: 16px;
  width: 37px;
}
#expiredTab ::ng-deep .p-inputswitch .p-inputswitch-slider:before {
  width: 0.81rem;
  height: 0.81rem;
  top: 11px;
}`, "",{"version":3,"sources":["webpack://./src/app/direct-link/direct-link.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AAAI;;;;EAII,kBAAA;EACA,UAAA;EACA,QAAA;EACA,cAAA;AAER;AAAQ;;;;EACI,iBAAA;AAKZ;AADI;EACI,WAAA;AAGR;AAAI;EACI,mBAAA;AAER;AAAI;EACI,iBAAA;EACA,gBAAA;AAER;AAGI;EACI,aAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AADR;AAGQ;EACI,eAAA;EACA,WAAA;EACA,eAAA;AADZ;AAGY;EACI,eAAA;EACA,gBAAA;AADhB;AAMI;EACI,eAAA;AAJR;AAOI;EACI,kBAAA;AALR;AAOQ;EACI,gBAAA;AALZ;AAQQ;EACI,aAAA;AANZ;AASQ;EACI,YAAA;AAPZ;AASY;EACI,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sCAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,qCAAA;EACA,gCAAA;EACA,gBAAA;AAPhB;AAWQ;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;AATZ;AAWY;EACI,YAAA;EACA,iBAAA;AAThB;AAeQ;EACI,2CAAA;EACA,4BAAA;EACA,yBAAA;AAbZ;AAeY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAbhB;AAiBQ;EACI,YAAA;EACA,WAAA;AAfZ;AAiBY;EACI,cAAA;EACA,eAAA;EACA,SAAA;AAfhB","sourcesContent":["#expiredTab {\n    height: 100%;\n    .p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close,\n    .p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close,\n    .p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close,\n    .p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close {\n        position: absolute;\n        right: 4px;\n        top: 4px;\n        color: #828282;\n\n        .pi {\n            font-weight: bold;\n        }\n    }\n\n    .body {\n        height: 85%;\n    }\n\n    .layout-topbar-logo {\n        align-items: center;\n    }\n    p {\n        margin-left: 20px;\n        margin-top: 20px;\n    }\n    .message-logo {\n        //background: white;\n    }\n    .font-size-header {\n        display: flex;\n        align-items: baseline;\n        font-size: 1rem;\n        color: #1d2125;\n        font-weight: normal;\n\n        button {\n            font-size: 10px;\n            width: 2rem;\n            margin-top: 4px;\n\n            ::ng-deep .pi-chevron-right {\n                font-size: 10px;\n                line-height: 9px;\n            }\n        }\n    }\n\n    .cursor {\n        cursor: pointer;\n    }\n\n    .bdp-map-wrapper {\n        position: relative;\n\n        #bdpDraggableWrapper {\n            overflow: hidden;\n        }\n\n        #tntDetailedMap {\n            height: 500px;\n        }\n\n        .ng-resizable-handle.ng-resizable-s {\n            height: 15px;\n\n            &::after {\n                /* width: 46px; */\n                /* height: 0px; */\n                content: \"\";\n                /* margin-left: auto; */\n                /* margin-right: 10px; */\n                /* display: block; */\n                /* margin-top: 3px; */\n                /* border-bottom: 7px solid #d3d3d4; */\n                float: right;\n                width: 0;\n                height: 0;\n                border-top: 10px solid transparent;\n                border-bottom: 30px solid transparent;\n                border-right: 12px solid #c9c9d0;\n                cursor: n-resize;\n            }\n        }\n\n        .bdp-switch-wrapper {\n            position: absolute;\n            bottom: 24px;\n            left: 25px;\n            background: #fff;\n            padding: 4px 5px 2px 5px;\n            border-radius: 5px;\n\n            & > span {\n                float: right;\n                margin-left: 15px;\n            }\n        }\n    }\n\n    ::ng-deep {\n        button.p-button {\n            background-color: var(--bdpButtonSecondary);\n            color: var(--bdpFontPrimary);\n            border: 1px solid #d7d8d9;\n\n            &.bdp-export-button {\n                width: 36px;\n                height: 36px;\n                margin-left: 1rem;\n            }\n        }\n\n        .p-inputswitch {\n            height: 16px;\n            width: 37px;\n\n            .p-inputswitch-slider:before {\n                width: 0.81rem;\n                height: 0.81rem;\n                top: 11px;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
